<template>
  <section class="contact-agency">
    <div
      class="prefilled-business"
      v-if="prefilledBusinessId"
    >
      <div class="title-wrapper">
        <form-head
          h2
          :is-centered="false"
          :title="$t('contact.selected_agency')"
        />
        <a
          @click="resetPrefilledBusiness()"
          aria-label="modifier"
        >
          <svg>
            <use xlink:href="#icon-pencil"></use>
          </svg>
        </a>
      </div>
      <div
        v-if="!prefilledBusiness"
        class="spinner-wrapper"
      >
        <rent-spinner />
      </div>
      <div
        v-if="prefilledBusiness"
        class="address-wrapper"
      >
        <span class="business-label">{{ prefilledBusiness.label }}</span><br>
        <span>{{ prefilledBusiness.address }},</span>
        <span>{{ prefilledBusiness.city.postal_code }}</span>
        <span>{{ prefilledBusiness.city.label_uppercase }}</span>
        <div class="phone-link">
          <svg>
            <use xlink:href="#icon-phone"></use>
          </svg>
          <a
            v-if="!phoneIsVisible"
            @click="phoneIsVisible = true"
          >
            Cliquer pour voir le téléphone
          </a>
          <a v-else>Tel: {{ prefilledBusiness.phone }}<br>Fax: {{ prefilledBusiness.fax }}</a>
        </div>
      </div>
    </div>
    <div
      class="choose-business-inputs"
      v-if="!prefilledBusinessId"
    >
      <div>
        <form-head
          h2
          :is-centered="false"
          :title="$t('contact.agency') + ' *'"
        />
      </div>
      <div>
        <booking-input
          :value="pickUp.value"
          :id="pickUp.id"
          :active="pickUp.active"
          :alert="pickUp.alert"
          :drop="false"
          :hide-pop-up="true"
          :show-details-left="true"
          geolocation
          @selected="selectedPickup"
          @focus="focusPickup"
          @blur="blurPickup"
        />
      </div>
      <ul
        v-if="error.$error && !prefilledBusiness"
        class="error"
      >
        <li>
          <span>{{ $t('contact.error_form') }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import queryString from 'query-string'
import FormHead from '../shared/inputs/FormHead';
import BookingInput from '../Booking/BookingInput';
import RentSpinner from '../shared/RentSpinner'

export default {
  components: {
    FormHead,
    BookingInput,
    RentSpinner,
  },
  props: {
    error: {
      type: Object,
      default: null,
    },
    business: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      prefilledBusinessId: this.businessId ? this.businessId : (queryString.parse(window.location.search).business_id || window.localStorage.rentPickupBusinessId),
      prefilledBusiness: null,
      phoneIsVisible: false,
      pickUp: {
        value: '',
        id: null,
        active: true,
        alert: false,
        clickSvg: true,
      },
      itemToEmit: {
        name: null,
        value: null,
      },
    };
  },
  computed: {
    ...mapState({
      api: (state) => state.api,
    }),
  },
  async mounted() {
    if (this.prefilledBusinessId) {
      const business = await axios.get(`${this.api}/businesses/${this.prefilledBusinessId}`)
      this.prefilledBusiness = business.data.data;
      this.pickUp.value = business.data.data.label;
      this.pickUp.id = business.data.data.id;
      this.$emit('updateInputs', business.data.data.id)
    }
  },
  methods: {
    selectedPickup(val) {
      this.udpateInputs(val);
    },
    focusPickup() {
      this.pickUp.value = '';
      this.pickUp.id = null;
    },
    blurPickup() {
      if (!this.pickUpBusiness || !this.pickUpBusiness.label) {
        return;
      }

      this.udpateInputs(this.pickUpBusiness.label, true);
    },
    async udpateInputs(value) {
      this.pickUp.value = value.label;
      this.pickUp.id = value.id;
      this.prefilledBusinessId = this.pickUp.id
      if (this.prefilledBusinessId) {
        const business = await axios.get(`${this.api}/businesses/${this.prefilledBusinessId}`)
        this.prefilledBusiness = business.data.data;
      }
      return this.$emit('updateInputs', value.id);
    },
    resetPrefilledBusiness() {
      this.prefilledBusinessId = null;
      this.prefilledBusiness = null;
      this.pickUp.value = '';
      this.pickUp.id = null;

      return this.$emit('updateInputs', '');
    },
  },
};
</script>
<style lang="scss" scoped>

.contact-agency {
  background-color: $c-alabaster;
  border: 1px solid #f0f0ef;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 20px 30px;

  @include teq-breakpoint($medium) {
    padding: 20px 50px;
  }

  .agency__inputs {
    width: 100%;

    li {
      margin: 0;
    }
  }

  .prefilled-business {
    .title-wrapper {
      display: flex;
      flex: 1;
      flex-direction: row;
      justify-content: space-between;

      a {
        cursor: pointer;
        height: 20px;
        width: 20px;

        svg {
          height: 20px;
          width: 20px;
        }
      }
    }

    .spinner-wrapper {
      align-items: center;
      display: flex;
      flex: 1;
      justify-content: center;
      padding: 10px 0;
    }

    .address-wrapper {
      padding: 10px 0;

      .business-label {
        color: black;

        @include font-size(14px);
      }

      .phone-link {
        align-items: center;
        cursor: pointer;
        display: flex;
        margin-top: 20px;

        svg {
          height: 20px;
          width: 20px;
        }

        a {
          color: black;

          @include font-size(11px);
        }
      }
    }
  }
}

.error span {
  @include errorInputs;
}
</style>
